<button id="TimerButton"
    class="{{state}} on_{{background}} {{timerState}}"
    [title]="getTooltip()"
    (click)="timerClicked.emit()">
    @if (state == 'badge') {
        <aurora-icon icon="stopwatch"></aurora-icon>
        @if (includeTimeInfo) {
        <span class="timer">
            <span id="TaskTime">
                <sm-time-since [start]="dueOn" [displayTimeUntil]="timerState != 'late'"/>
            </span>
        </span>
        }
    } @else if (state == 'bar') {
        <span class="timer_badge--task_name single_line_ellipsis">
            <h2 id="TaskName" class="sle">{{ taskName }}</h2>
        </span>
        <button class="inner {{timerState}}" [ngClass]="{ 'badge': timerState != 'late', 'standalone standalone_on_red': timerState == 'late'}">
            <aurora-icon icon="stopwatch"></aurora-icon>
            @if (includeTimeInfo) {
            <span class="timer">
                <span id="TaskTime">
                    <sm-time-since [start]="dueOn" [displayTimeUntil]="timerState != 'late'"/>
                </span>
            </span>
            }
        </button>     
    } @else {
        @if (timerState != 'late') {
        <aurora-icon icon="stopwatch"></aurora-icon>
        }
        @if (timerState == 'late') {
        <aurora-icon icon="stopwatch-fill"></aurora-icon>
        }
        @if (includeTimeInfo) {
        <sm-time-since id="TaskTime" [start]="dueOn" [displayTimeUntil]="timerState != 'late'"/>
        }
    }
</button>
